export class DumpsterListDeassociateCollectionPointInput {
  dumpsters: number[];

  constructor(dumpsters: number[]) {
    this.dumpsters = dumpsters;
  }
}
